<template>
  <v-card outlined>
    <v-card-text>
      <v-data-table
        flat 
        disable-sort
        class="mb-3 title" 
        hide-default-footer
        loader-height="2"
        :headers="headers"
        :loading="loading"
        :items="farmers.data">
      </v-data-table>
      <app-pagination
        v-if="farmers.meta"
        :meta="farmers.meta"
        @pageChanged="pageChanged"
      ></app-pagination>
    </v-card-text>
  </v-card>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      page: 1,
      loading: true,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Entity Type', value: 'entity_type' },
        { text: 'Contact Person', value: 'contact_person.name' },
        { text: 'Date Registered', value: 'registered_at' },
      ],
    }
  },

  computed: {
    ...mapGetters({
      farmers: 'getFarmers'
    })
  },

  methods: {
    ...mapActions([
      'setFarmers'
    ]),

    pageChanged (page) {
      this.page = page
      this.setFarmers()
    },
  },

  mounted () {
    this.setFarmers().then(() => {
      this.loading = false
    })
  }
}
</script>